<template>
  <b-dropdown
    :text="
      value
        ? selectedTime + calculateDuration(value)
        : placeholder
        ? placeholder
        : 'Time'
    "
    :class="squared ? 'squared' : 'rounded'"
    class="container-main border-input-color border container-main-dropdown"
    :toggle-class="
      'form-control d-flex flex-row justify-content-between align-items-center bg-transparent border-0' +
        (!value ? ' color-custom-dark-grey' : ' text-dark')
    "
    menu-class="container-main-menu"
    :no-flip="true"
    block
    :disabled="disabled"
  >
    <b-dropdown-header>
      <div
        v-if="showAllDay"
        class="d-flex justify-content-start align-items-center mb-2"
      >
        <vue-toggles
          @click="value == 'allDay' ? selectTime('') : selectTime('allDay')"
          :value="value == 'allDay'"
          height="30"
          width="50"
          checkedText=""
          uncheckedText=""
          checkedBg="#34C759"
          uncheckedBg="#FF6161"
        />
        <span class="ml-2">All Day</span>
      </div>
      <div>
        <b-time v-model="controlValue" locale="en"></b-time>
      </div>
      <div class="mt-2">
        <b-button
          size="sm"
          variant="outline-danger"
          v-if="value"
          @click="clearTime"
        >
          Clear time
        </b-button>
      </div>
    </b-dropdown-header>
    <div class="time-options-container">
      <b-dropdown-item-button
        @click="selectTime(timeOption.value)"
        v-for="timeOption in timeOptions"
        :key="timeOption.value"
      >
        {{ timeOption.text + calculateDuration(timeOption.value) }}
      </b-dropdown-item-button>
    </div>
  </b-dropdown>
</template>

<script>
import moment from "moment";
export default {
  name: "TimePicker",
  props: [
    "placeholder",
    "value",
    "beginTime",
    "endTime",
    "durationFrom",
    "squared",
    "disabled",
    "showAllDay"
  ],
  data: () => ({
    intervalFirstHourMinutes: 15,
    intervalMinutes: 30
  }),
  methods: {
    selectTime(optionValue) {
      this.controlValue = optionValue;
    },
    calculateDuration(toValue) {
      const duration = moment.duration(
        moment(toValue, "HH:mm").diff(moment(this.durationFrom, "HH:mm"))
      );
      const hours = duration.asHours();
      if (hours >= 1) {
        return this.durationFrom
          ? ` (${parseFloat(hours.toFixed(2))} ${hours == 1 ? "hr" : "hrs"})`
          : "";
      }
      const minutes = duration.asMinutes();
      return this.durationFrom ? ` (${minutes} mins)` : "";
    },
    clearTime() {
      this.controlValue = "";
    }
  },
  computed: {
    controlValue: {
      get() {
        return this.value;
      },
      set(newValue, oldValue) {
        if (oldValue != newValue) {
          if (newValue == "") {
            this.$emit("input", "");
          } else if (newValue == "allDay") {
            this.$emit("input", "allDay");
          } else {
            const time = moment(newValue.slice(0, 5), "HH:mm");

            if (!this.beginTime || !this.endTime) {
              this.$emit("input", newValue.slice(0, 5));
              return;
            }

            const beginTime = moment(this.beginTime, "HH:mm");
            const endTime = moment(this.endTime, "HH:mm");

            if (time.isBefore(beginTime)) {
              const diff = beginTime.diff(time);

              if (diff < 3600000 && endTime.minutes() === 0) {
                endTime.subtract(diff);
              }

              this.$emit("input", endTime.format("HH:mm"));
            } else if (time.isAfter(endTime)) {
              const diff = endTime.diff(time);

              if (diff > -3600000 && beginTime.minutes() === 0) {
                beginTime.subtract(diff);
              }

              this.$emit("input", beginTime.format("HH:mm"));
            } else {
              this.$emit("input", time.format("HH:mm"));
            }
          }
        }
      }
    },
    selectedTime() {
      return this.value == "allDay"
        ? "All Day"
        : moment(this.value, "HH:mm").format("hh:mm A");
    },
    timeOptions() {
      const timeOptions = [];
      let currentTime = moment(this.beginTime, "HH:mm")
        .add(this.intervalFirstHourMinutes, "minutes")
        .format("HH:mm");
      while (currentTime < this.endTime) {
        timeOptions.push({
          value: currentTime,
          text: moment(currentTime, "HH:mm").format("hh:mm A")
        });
        let intervalMinutes = this.intervalMinutes;
        if (timeOptions.length < 4)
          intervalMinutes = this.intervalFirstHourMinutes;
        const newCurrentTime = moment(currentTime, "HH:mm")
          .add(intervalMinutes, "minutes")
          .format("HH:mm");
        if (newCurrentTime < currentTime) break;
        currentTime = newCurrentTime;
      }
      return timeOptions;
    }
  },
  watch: {
    beginTime(newValue) {
      if (newValue > this.value) {
        this.controlValue = newValue;
      }
    }
  }
};
</script>

<style scoped>
.time-options-container {
  max-height: 200px;
  overflow-y: scroll;
}
.container-main {
  height: 38px;
  background-color: white;
}
</style>
<style>
.container-main-dropdown .color-custom-dark-grey.btn-secondary:hover,
.container-main-dropdown .color-custom-dark-grey.btn-secondary:focus,
.container-main-dropdown .color-custom-dark-grey.btn-secondary.dropdown-toggle {
  color: #909db8 !important;
}
</style>
